import React from "react";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

interface VisitStatusBadgeProps {
  status: string | null;
}

export const VisitStatusBadge: React.FC<VisitStatusBadgeProps> = ({
  status
}) => {
  const { t } = useTranslation();

  if (!status) return null;

  const statusConfig = {
    confirmed: { variant: "default" as const, text: t('confirmed'), className: "bg-green-100 text-green-800 border-green-200" },
    pending: { variant: "secondary" as const, text: t('pending'), className: "bg-yellow-100 text-yellow-800 border-yellow-200" },
    cancelled: { variant: "destructive" as const, text: t('cancelled'), className: "" },
    completed: { variant: "default" as const, text: t('completed'), className: "bg-blue-100 text-blue-800 border-blue-200" },
    no_show: { variant: "outline" as const, text: t('no_show'), className: "bg-orange-100 text-orange-800 border-orange-200" }
  };

  const config = statusConfig[status as keyof typeof statusConfig];
  if (!config) return null;

  return (
    <Badge variant={config.variant} className={`text-xs ${config.className}`}>
      {config.text}
    </Badge>
  );
};